import { lazy, Suspense, useEffect, useState } from "react";
import Loader from "@/components/other/loader/Loader";
import LoaderSmall from "@/components/other/loader/LoaderSmall";
import HeaderMobile from "@/components/base/HeaderMobile";
import Header from "@/components/base/Header";
import WhatsAppIcon from '/public/images/whatsapp.webp';
import Image from "next/image";
import Footer from "@/components/base/Footer";
import ForceSSRLink from "@/components/other/ForceSSRLink";
import FooterNew from "@/components/base/FooterNew";


export default function MainWrapper({
                                        regionsData,
                                        headerData,
                                        footerData,
                                        socialLinks,
                                        searchOptions,
                                        isWorldTour,
                                        dropdownData,
                                        children,
                                        isMobileDefault,
                                        whatsappData,
                                        variant,
                                    }) {
    const bookingButton = dropdownData?.find(item => item?.item_type === 'booking_button');

    function generateWhatsAppLink(phoneNumber, text) {

        if(!phoneNumber || !text){
            return null;
        }

        return `https://api.whatsapp.com/send/?phone=${encodeURIComponent(phoneNumber)}&text=${encodeURIComponent(text)}`;
    }

    return (
        <div>




            <div className="mobile_only">
                {
                    (whatsappData?.number && whatsappData?.message) &&
                    <ForceSSRLink
                        href={generateWhatsAppLink(whatsappData?.number ,whatsappData?.message)}
                        target="_blank"
                        style={{
                            position: "fixed",
                            width: "60px",
                            height: "60px",
                            bottom: "60px",
                            right: "10px",
                            backgroundColor: "#25d366",
                            color: "#FFF",
                            borderRadius: "50px",
                            textAlign: "center",
                            fontSize: "30px",
                            boxShadow: "1px 1px 2px #999",
                            zIndex: 99999,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: 'pointer',
                        }}
                    >
                        <Image src={WhatsAppIcon} alt="WahtsApp" width={30} height={30}/>
                    </ForceSSRLink>
                }


                {
                    bookingButton && <ForceSSRLink
                        href={bookingButton.item_link}
                        style={{
                            zIndex: 9999,
                            position: "fixed",
                            bottom: 0,
                            right: 0,
                            backgroundColor: "#FF5A5F",
                            color: "white",
                            padding: "0 50px",
                            height: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textDecoration: "none",
                            fontSize: "14px",
                            lineHeight: "14px",

                        }}
                    > {bookingButton?.item_title}</ForceSSRLink>
                }
            </div>


            {/* Lazy-loaded Header */}
                <div className="mobile_only">
                    <HeaderMobile
                        regions={regionsData}
                        headerData={headerData}
                        searchOptions={searchOptions}
                        socialLinks={socialLinks}
                        isWorldTour={isWorldTour}
                        dropdownData={dropdownData}
                    />
                </div>

                <div className="desktop_only">
                    <Header
                        regions={regionsData}
                        headerData={headerData}
                        searchOptions={searchOptions}
                        socialLinks={socialLinks}
                        isWorldTour={isWorldTour}
                        dropdownData={dropdownData}
                    />
                </div>

                {/*<HeaderComponent*/}
                {/*/>*/}

            {/* Main Content */}
            <>{children}</>

            {/* Footer */}
                <FooterNew
                    footerData={footerData}
                    socialLinks={socialLinks}
                />
        </div>
    );
}
